export const MIN_RANGE_POINTER = 'min';
export const MAX_RANGE_POINTER = 'max';
